import { render } from "./EditEraklient.vue?vue&type=template&id=2c354a06&scoped=true"
import script from "./EditEraklient.vue?vue&type=script&lang=js"
export * from "./EditEraklient.vue?vue&type=script&lang=js"

import "./EditEraklient.vue?vue&type=style&index=0&id=2c354a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c354a06"]])

export default __exports__